import I18n from 'core/i18n'
import * as React from 'react'
import styled from 'styled-components'
import { withHtmlTag } from '../../utils'
import * as constants from '../../static/constants'

const TextWrapStyle = styled.div`
  .Content {
    margin-top: ${props => (props.noMargin ? 0 : 24)}px;
    white-space: pre-wrap;
    overflow: hidden;
    @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
      font-size: 14px;
    }
    &.hide {
      max-height: 4.5em;
      @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
        max-height: 6em;
      }
    }
  }

  .Content_Toggle {
    display: inline-block;
    font-size: 1.4rem;
    margin-top: 0.8rem;
    text-decoration: underline;
    text-transform: capitalize;
    color: ${constants.COLORS.primary};
    cursor: pointer;
    &:hover {
      text-decoration: none;
    }
  }
`
const TextWrap: React.FC<{ text: string; noMargin?: boolean }> = ({ text, noMargin }) => {
  const bodyRef = React.useRef<HTMLDivElement>(null)
  if (text === null) {
    text = ''
  }
  const [showTextAll, setShowTextAll] = React.useState(false)
  const [isOverflowing, setIsOverflowing] = React.useState(false)

  React.useLayoutEffect(() => {
    if (!bodyRef.current) {
      return
    }
    const el = bodyRef.current
    setIsOverflowing(el.scrollHeight > el.clientHeight)
  }, [text])

  return (
    <TextWrapStyle noMargin={noMargin}>
      <div className={`Content${showTextAll ? '' : ' hide'}`} ref={bodyRef}>
        <div dangerouslySetInnerHTML={{ __html: withHtmlTag(text) }} />
      </div>
      {isOverflowing && (
        <div className="Content_Toggle" onClick={() => setShowTextAll(old => !old)}>
          {showTextAll ? I18n.t('generic.show_less') : I18n.t('generic.show_more')}
        </div>
      )}
    </TextWrapStyle>
  )
}

export default TextWrap
